<template>
  <div class="container">
    <b-alert variant="danger" :show="hasError" dismissible>
      {{ error }}
    </b-alert>

    <form class="formContainer" v-on:submit.prevent="onSubmit">
      <h1>Login page</h1>
      <div class="form-group">
        <label for="username">Username</label>
        <input
          v-model="username"
          type="username"
          class="form-control"
          id="username"
          required
        />
      </div>
      <div class="form-group">
        <label for="password">Password</label>
        <input
          v-model="password"
          type="password"
          class="form-control"
          id="password"
          required
        />
      </div>
      <button
        :disabled="!username || !password"
        type="submit"
        class="btn btn-primary"
      >
        Submit
      </button>
    </form>
  </div>
</template>

<script>
  import axios from 'axios'
  import { useAuthStore } from '@/stores/auth'

  export default {
    name: 'LoginPage',
    data() {
      return {
        error: null,
        username: null,
        password: null,
      }
    },
    computed: {
      hasError() {
        return this.error !== null
      },
    },
    methods: {
      onSubmit() {
        this.error = null

        axios
          .post('api/user/login', {
            username: this.username,
            password: this.password,
          })
          .then((response) => {
            const token = response.data.token
            if (token) {
              const authStore = useAuthStore()
              authStore.login(token)
              this.$router.push('/')
            }
          })
          .catch((e) => {
            this.error = e.response?.data?.message || e.message
          })
      },
    },
  }
</script>

<style scoped>
  .formContainer {
    width: 40%;
    margin-top: 2%;
  }
</style>
